<template>
  <div class="fifl-footer">
    <span class="fifl-inc">© FIFL Inc.</span>
  </div>
</template>

<script>
export default {
	name: "FiflFooter",
};
</script>

<style lang="scss">
.fifl-footer {
	width: 100%;
	height: 60px;
	line-height: 60px;
	padding: 0 36px;

	.fifl-inc {
		width: 96px;
		font-family: HelveticaNeue;
		font-size: 11px;
		font-weight: normal;
		font-style: normal;
		font-stretch: normal;
		letter-spacing: -0.5px;
		text-align: center;
		color: #9b9b9b;
	}

	@media screen and (max-width: 768px) {
		height: 45px;
		line-height: 45px;

		.fifl-inc {
			display: block;
			width: 100%;
			font-family: HelveticaNeue;
			font-size: 11px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			letter-spacing: -0.5px;
			text-align: center;
			color: #9b9b9b;
		}
	}
}
</style>
